import axios from 'axios';
import { getUser, logOut } from '../utils/persist';
import FlashMessage from '../components/FlashMessage';

require('dotenv').config({ path: `${process.cwd()}/.env.local` });

const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH ?? '/api/v1';

const http = axios.create({
  baseURL: `${window.location.protocol}//${window.location.host}:${window.location.port}${API_BASE_PATH}`,
});

http.interceptors.request.use((config) => {
  // Get fresh token every request
  const user = getUser();

  if (user) {
    config.headers.common.Authorization = `Bearer ${user.token}`;
  }

  return config;
});

http.interceptors.response.use(
  (response) => {
    const notification = response?.config.notify ?? null;

    if (notification !== false) {
      switch (response?.config.method) {
        case 'put':
        case 'patch':
          FlashMessage.success(notification || 'Elemento aggiornato');
          break;
        case 'post':
          FlashMessage.success(notification || (response.status === 201 ? 'Elemento creato' : 'Elemento aggiornato'));
          break;
        case 'delete':
          FlashMessage.warning(notification || 'Elemento eliminato');
          break;
      }
    }

    return response;
  },
  (error) => {
    const { response } = error;
    const notification = response?.config.notify ?? null;

    let message = 'Something gone wrong!';

    switch (response?.status) {
      case 401:
      case 403:
        logOut();
        break;
      case 406:
        message = 'Valori non validi o mancanti';
        break;
      case 409:
        message = 'Questo elemento non può essere eliminato perché è collegato ad altri dati. Rimuovi prima i dati correlati e riprova.';
        break;
      case 422:
        message = 'Valori duplicati o non univoci';
        break;
      case 500:
        message = 'Errore del server';
        break;
      case 502:
      case 503:
      case 504:
        message = 'Impossibile comunicare con il server';
        break;
    }

    // eslint-disable-next-line no-console
    console.error(`${response?.config.method.toUpperCase() ?? ''} ${response?.config.url ?? 'ERROR'}: ${message}`);

    if (notification !== false) FlashMessage.error(message);

    return Promise.reject(error);
  },
);

export default http;
